import { get, getResultFromResponse } from '../request';
import { isRunAsSubApp } from '../wujie';

export type UserInfo = {
  id: number;
  username: string;
  country_code: string;
  status: string;
  email_verified: boolean;
  mobile_verified: boolean;
  avatar: string;
  auto_add_margin: boolean;
  currency_code: string;
  created_at: string;
  vague_mobile: string;
  vague_email: string;
  vague_email_v2: string;
  has_google2fa: boolean;
  lang: string;
  use_ws2: boolean;
  use_svc_order: boolean;
  use_order_v2: boolean;
  double_confirm: string;
  use_ws2_for_personal: boolean;
  use_webworker: boolean;
  msg_disable_module_ids: string;
  ws3_path: string;
  account_label: null | string;
  is_submember: boolean;
  parent_member_id: number;
  submember_gray_allow: boolean;
  member_tag: {
    change_utc_time_zone: string;
    registered_member_type: string;
  };
  credit_card_deposit_gray: {
    APP: boolean;
    OnRamp: boolean;
    Paxful: boolean;
    Simplex: boolean;
  };
  ref_id: number;
  parent_verify_method: string;
  of_affiliate_user: boolean;
  is_wallet_gray_user: boolean;
  banStatus: {
    login: number;
    trade: number;
    withdraw: number;
    trade_banned_detail: {
      future: Record<string, unknown>;
      spot: {
        type: number[];
      };
      unified: Record<string, unknown>;
      fiat: {
        platform_credit_card: Record<string, unknown>;
        p2p: Record<string, unknown>;
        third_party_payment_channel: Record<string, unknown>;
      };
    };
    is_normal: boolean;
    withdraw_ban_detail: Record<string, unknown>;
  };
  is_deposit: boolean;
  option_gray: boolean;
  asset_gray: boolean;
  mv_php_gray: boolean;
  lb_exchange_gray: boolean;
  usdc_linear_gray: boolean;
  has_mt4: boolean;
  is_bot_user: boolean;
  is_copy_trading_leader: boolean;
  is_copy_trading_follower: boolean;
  loyalty_vip_info: {
    is_child_member: boolean;
    is_vip: boolean;
    label_level: number;
    label_type: number;
    mm_derivative_ended_at: number;
    mm_derivative_level: number;
    mm_spot_level: string;
    vip_status: number;
  };
  fullPositionStatus: string;
  isFiat: boolean;
  unified_account: number;
  platform: string;
  grayFlag: {
    IsFA: boolean;
    'IsFA-Earn': boolean;
    IsInternalTransfer: boolean;
    IsP2P: boolean;
    IsUTA: boolean;
    IsUTASpotClose: boolean;
    fiatConvert: boolean;
    fundingBlockTradeConvert: boolean;
    isBlockTradeConvert: boolean;
    isFundingConvert: boolean;
    isInternalSecureComponent: boolean;
    isSecureComponent: boolean;
    isSpotConvert: boolean;
    spotBlockTradeConvert: boolean;
    test11: boolean;
    utaBlockTradeConvert: boolean;
    utaConvert: boolean;
    utaSmallAsset: boolean;
  };
  hid: string;
  kyc_person_level: number;
  client_ip: string;
  client_country: string;
  risk: number;
  demo_id: number;
};

const mock = {
  id: 3822097,
  username: '',
  country_code: '',
  status: 'Normal',
  email_verified: true,
  mobile_verified: false,
  avatar: '',
  auto_add_margin: false,
  currency_code: '',
  created_at: '2024-05-27 18:49:36',
  vague_mobile: '',
  vague_email: 'miller.zhou0103@gmail.com',
  vague_email_v2: 'mil***@****',
  has_google2fa: false,
  lang: 'en',
  use_ws2: false,
  use_svc_order: true,
  use_order_v2: true,
  double_confirm:
    'positionConfirm,obAnimation,orderConfirm,hidePhoneConfirm,cancelAllConfirm',
  use_ws2_for_personal: true,
  use_webworker: true,
  msg_disable_module_ids: '',
  ws3_path: 'realtime_private_7_10',
  account_label: null,
  is_submember: false,
  parent_member_id: 0,
  submember_gray_allow: true,
  member_tag: {
    change_utc_time_zone: '24',
    registered_member_type: 'derivatives',
  },
  credit_card_deposit_gray: {
    APP: false,
    OnRamp: true,
    Paxful: true,
    Simplex: true,
  },
  ref_id: 3900644420,
  parent_verify_method: '',
  of_affiliate_user: false,
  is_wallet_gray_user: true,
  banStatus: {
    login: 1,
    trade: 1,
    withdraw: 1,
    trade_banned_detail: {
      future: {},
      spot: {
        type: [1],
      },
      unified: {},
      fiat: {
        platform_credit_card: {},
        p2p: {},
        third_party_payment_channel: {},
      },
    },
    is_normal: true,
    withdraw_ban_detail: {},
  },
  is_deposit: false,
  option_gray: true,
  asset_gray: true,
  mv_php_gray: true,
  lb_exchange_gray: true,
  usdc_linear_gray: true,
  has_mt4: false,
  is_bot_user: false,
  is_copy_trading_leader: false,
  is_copy_trading_follower: false,
  fullPositionStatus: 'I',
  isFiat: true,
  unified_account: 0,
  platform: 'pc',
  grayFlag: {
    IsFA: true,
    'IsFA-Earn': false,
    IsInternalTransfer: true,
    IsP2P: false,
    IsUTA: true,
    IsUTASpotClose: true,
    fiatConvert: true,
    fundingBlockTradeConvert: true,
    isBlockTradeConvert: true,
    isFundingConvert: true,
    isInternalSecureComponent: true,
    isSecureComponent: true,
    isSpotConvert: true,
    spotBlockTradeConvert: true,
    test11: false,
    utaBlockTradeConvert: true,
    utaConvert: true,
    utaSmallAsset: true,
  },
  hid: 'z5P92X',
  kyc_person_level: 0,
  client_ip: '10.18.4.133',
  client_country: '',
  risk: 0,
  demo_id: 0,
};

export const getUserInfo = async () => {
  if (isRunAsSubApp) {
    return (window as any).$wujie?.props?.getUserInfo() as UserInfo;
  }
  return getResultFromResponse(
    get<UserInfo>('/v2/private/user/profile', {
      withCredentials: true,
    })
  );
};

/** 钱包类型 */
export enum WalletSymbolTypes {
  BYBITCLOUD = 'Bybit',
  BYBITEX = 'com.bybit',
  METAMASK = 'io.metamask',
  WALLETCONNECT = 'walletConnect',
}

/** 链类型 */
export enum WalletChainTypes {
  EVM = 1,
  SUI = 2,
  SOLANA = 3,
  BTC = 4,
  STACKS = 5,
  TON = 7,
  TRON = 8,
}
/** 链数据 */
export type Chain = {
  /** 链ID */
  chainId: string;
  /** 链Code */
  chainCode: string;
  /** 链名称 */
  chainName: string;
  /** 日间图标 */
  iconDayUrl: string;
  /** 夜间图标 */
  iconNightUrl: string;
  /** 基础币种 */
  baseTokenName: string;
  /** @deprecated 基础币种 */
  baseToken: string;
  /** 网络 */
  networkName: string;
  /** 排序  */
  order: number;
  /** 支持L1的Gas */
  isSupportL1Gas: number;
  /** 链类型 */
  chainType: WalletChainTypes;
  /** 区分EIP1559，暂时无用 */
  gasType: 1;
  /** txAddress */
  txAddress: string;
  /** 链是否开放 */
  tmpStatus: 'open' | 'close';
  /** 创建时间 */
  createAt: number;
  /** 最小交易金额 */
  minTransaction: string;
};
/** 获取链列表 */
export const queryChainList = () => {
  return get<{
    walletChains: {
      CLOUD: { itemList: Chain[] };
      MNEMONIC_PHRASE: { itemList: Chain[] };
      MPC: {
        itemList: Chain[];
      };
    };
  }>('/web3/wallet/v1/private/mgmt/chain/list');
};

export const getCloudWalletList = async () => {
  if (isRunAsSubApp) {
    return (window as any).$wujie?.props?.getCloudWalletList();
  }
};

export const getCurrentWallet = async () => {
  if (isRunAsSubApp) {
    return (window as any).$wujie?.props?.getCurrentWallet();
  }
};

export const getChains = async () => {
  if (isRunAsSubApp) {
    return (window as any).$wujie?.props?.getChains();
  }
};
